import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import { PlatformProvider } from 'shared/providers';
import { overrideWindowOpen } from 'shared/utils';
import * as Sentry from '@sentry/react';
import { AlertProvider } from 'shared/ui/components/alert/alert';
import { PurchaseModalProvider } from 'shared/ui/components/modal/modal-purchase';
import { CelebrationModalProvider } from 'shared/ui/components/modal/celebration-modal';

// console.log(process.env);

export const sentryClient = Sentry.init({
  dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  environment: import.meta.env.REACT_APP_ENV,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// console.log('[Debug]: Sentry', sentryClient);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

window?.Telegram?.WebApp.expand();
window?.Telegram?.WebApp.disableVerticalSwipes();
window?.Telegram?.WebApp.ready();
overrideWindowOpen();

root.render(
  <BrowserRouter>
    <PlatformProvider>
      <PurchaseModalProvider>
        <CelebrationModalProvider>
          <AlertProvider>
            <App />
          </AlertProvider>
        </CelebrationModalProvider>
      </PurchaseModalProvider>
    </PlatformProvider>
  </BrowserRouter>,
);
